import SrQiankunWorkFlow from "./SrQiankunWorkFlow.vue";

SrQiankunWorkFlow.install = function(Vue) {
  Vue.component(SrQiankunWorkFlow.name, SrQiankunWorkFlow);
};

export default SrQiankunWorkFlow;


// WEBPACK FOOTER //
// ./packages/SrQiankunWorkFlow/index.js